import React from 'react'
import Header from '../repeat/Header'
import Footer from '../repeat/Footer'
import HostelDetails from './code/hostelDetails'
import HostelData from './code/hosteldata'

const Hostel = () => {
  return (
    <div style={{backfaceVisibility:"#e9eaf0"}}>
      <div>
        <Header />
      </div>
      <div>
      <HostelData/>
      </div>
      <div>
      <HostelDetails />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}

export default Hostel
